import { EditLogin } from './edit-login.page';

export { EditLogin };
